/** @format */

import { cardUrl } from '../Config/Url';
import axios from 'axios';

export const cardServices = {
	getAllCards,
	createCard,
	updateCard,
	deleteCard,
};

async function getAllCards() {
	return axios
		.get(`${cardUrl}/all`)
		.then(res => res)
		.catch(err => err.response);
}

async function createCard(name) {
	return axios
		.post(`${cardUrl}`, { name })
		.then(res => res)
		.catch(err => err.response);
}

async function updateCard(id, name) {
	return axios
		.put(`${cardUrl}/${id}`, { name })
		.then(res => res)
		.catch(err => err.response);
}

async function deleteCard(id) {
	return axios
		.delete(`${cardUrl}/${id}`)
		.then(res => res)
		.catch(err => err.response);
}
